// 问题类型配置

const wtOptions_zh = [
    "其他",
    "图面问题",
    "图纸缺失",
    "图纸不一致",
    "净高问题",
    "碰撞问题",
    "预留洞口",
    "设计优化",
]

const wtOptions_en = [
    "Other",
    "Drawing Issues",
    "Missing Drawings",
    "Inconsistent Drawings",
    "Clear Height Issues",
    "Collision Issues",
    "Reserved Openings",
    "Design Optimization",
]

export { wtOptions_zh, wtOptions_en }
